export default __webpack_public_path__ + "static/media/logo.67d73be1.svg";